export default __webpack_public_path__ + "images/U8.944285f.png";